import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Layout,
  message,
  Row,
  Select,
  Typography,
} from "antd";
import { getData, postData, putData } from "apiServices/common";
import AppPageHeader from "common/PageHeader";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { getTypes } from "../utils/getTypes";

const MachineConfigForm = (props) => {
  const { type: maintenanceType } = props;
  //   Routes
  const navigate = useNavigate();
  const { id } = useParams();
  const { pathname } = useLocation();

  const isView = pathname.includes("view");

  const formType = useMemo(() => {
    getTypes(maintenanceType);
    return getTypes(maintenanceType);
  }, [maintenanceType]);

  //   Antd Constants
  const [form] = Form.useForm();

  const extra = (
    <div className="extra-button-container">
      <Button
        size="small"
        htmlType="submit"
        style={{ marginRight: 5 }}
        onClick={() => {
          form.resetFields();
          navigate(`/digitalization/machine-maintenance/configurations/${maintenanceType}`);
        }}
      >
        {" "}
        Back
      </Button>
      {isView ? null : (
        <Button
          htmlType="submit"
          type="primary"
          size="small"
          onClick={() => form.submit()}
          style={{ marginRight: 5 }}
        >
          {" "}
          {id ? "Update" : "Save"}
        </Button>
      )}
    </div>
  );

  useEffect(() => {
    if (id) {
      const fetchDetails = async () => {
        try {
          const response = await getData(
            `/api/digitalization/machine-maintenance/${formType}/${id}`,
            null,
            {},
          );
          const data = response.data?.data;
          console.log("🚀 ~ fetchDetails ~ data:", data)

          form.setFieldsValue({
            name: data.name,
          });
        } catch (error) {
          message.error("Failed to fetch details");
        }
      };
      fetchDetails();
    }
  }, [id, form]);

  const handleSubmit = async (values) => {
    const payload = values;
    try {
      if (id) {
        await putData(
          `/api/digitalization/machine-maintenance/${formType}/${id}`,
          payload,
        );
        message.success("Machine information updated successfully");
      } else {
        await postData(
          `/api/digitalization/machine-maintenance/${formType}`,
          payload,
        );
        message.success("Machine information added successfully");
      }
      navigate(`/digitalization/machine-maintenance/configurations/${maintenanceType}`);
    } catch (error) {
      message.error("Failed to submit machine information");
    }
  };

  return (
    <>
      <AppPageHeader
        title={
          <Typography.Title level={5} style={{ textTransform: "capitalize" }}>
            {id ? "Update" : "Add"} {maintenanceType}
          </Typography.Title>
        }
        extra={extra}
      />

      <Layout.Content className="item-details">
        <Card
          title={null}
          style={{ marginTop: 20, boxShadow: "none" }}
          bordered={false}
        >
          <Row gutter={16}>
            <Form
              form={form}
              layout="vertical"
              style={{ width: "100%" }}
              onFinish={handleSubmit}
              disabled={isView}
            >
              <Row gutter={16}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: "Name is required" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Layout.Content>
    </>
  );
};

export default MachineConfigForm;
